import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  ActiveStatus,
  AddAgent,
  AgentList,
  BodyClass,
  BodyInner,
  Box,
  BoxName,
  ButtonClass,
  DataWrapperClass,
  DialInput,
  Footer,
  Header,
  InnerBody,
  InputBox,
  MainBody,
  MainBodyClass,
  MainBox,
  OuterCall,
  OuterFooter,
  OverflowClass,
  Row,
  RowTitle,
} from "./styles";
import { Wrapper } from "modules/theme";
import { Link } from "react-router-dom";
import LeftContent from "./modules/leftContent";
import MiddleContent from "./modules/middleContent";
import RightContent from "./modules/rightContent";
import "./index.css";
import { useEffect } from "react";
import { messageAction } from "../../../store/action";
import { chatSelector, globalStateSelector } from "../../../store/selector";
import { connect } from "react-redux";
import ImagePicker from "./components/ImageLibrary/ImagePicker";
import DocumentPicker from "./components/DocumentLibrary/DocumentPicker";
import AudioPicker from "./components/AudioLibrary/AudioPicker";
import ContactRightPartTheme from "../../theme/theme1/common/components/ContactRightPartTheme";
import { Col } from "react-bootstrap";
import { useState } from "react";

const getUserId = (currentUser) => {
  if (currentUser) {
    if (currentUser._id) {
      return currentUser._id;
    } else if (currentUser.userId) {
      return currentUser.userId;
    }
  } else {
    return "";
  }
};

function ChatScreen({ showCustomerInfo, selectedAssignedList, ...props }) {
  const { isConnected, uniqueTeamIds, status, isOffline, offlineState } = props;
  // const [isOffline, setIsOffline] = useState(!isConnected);
  console.log('uniqueTeamIdsindex', uniqueTeamIds)
  console.log("socket information 0 ", isConnected);
  console.log('isOffline', isOffline)

  // useEffect(() => {
  //   // Event listeners for online/offline status
  //   const handleOffline = () => {
  //     console.log("Internet disconnected");
  //     // setIsOffline(true);
  //     // dynamicUpdate({ data: { key: "isOffline", value: true } });
  //     // dispatch(messageAction.offlineState({ isOffline: true }));
  //     offlineState(true);

  //   };

  //   const handleOnline = () => {
  //     console.log("Internet reconnected");
  //     // setIsOffline(false);
  //     // dynamicUpdate({ data: { key: "isOffline", value: false } });
  //     // dispatch(messageAction.offlineState({ isOffline: false }));
  //     offlineState(false);
  //   };

  //   window.addEventListener("offline", handleOffline);
  //   window.addEventListener("online", handleOnline);

  //   return () => {
  //     window.removeEventListener("offline", handleOffline);
  //     window.removeEventListener("online", handleOnline);
  //   };
  // }, []);

  useEffect(() => {
    const handleOffline = () => {
      console.log("Internet disconnected");
      offlineState(true); // Use offlineState instead of dispatch
    };

    const handleOnline = () => {
      const { configProcessor } = props;
      console.log("Internet reconnected");
      offlineState(false); // Use offlineState instead of dispatch
      configProcessor("getHistory", {
        identifier: selectedAssignedList.identifier,
      });
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [offlineState]);



  useEffect(() => {
    const { configProcessor, currentUser } = props;
    console.log("socket information ", isConnected);
    if (isConnected) {
      configProcessor("getAgentCurrentState", {
        userId: getUserId(currentUser),
        userState: status
      });
      configProcessor("getCannedMessages", {
        userId: getUserId(currentUser),
      });
    }

  }, [isConnected]);

  useEffect(() => {
    const { configProcessor } = props;
    if (uniqueTeamIds) {
      configProcessor(`messageTagList`, { teamId: uniqueTeamIds });
    }
  }, [uniqueTeamIds])

  console.log("showCustomerInfo", showCustomerInfo);

  // useEffect(() => {
  //   Notification.requestPermission();
  // }, []);

  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission();
    } else {
      console.warn("Notifications are not supported in this browser.");
    }
  }, []);

  window.addEventListener("offline", function () {
    console.log('Close Internet')
  })

  return (
    <div className="heightClass">
      <DataWrapperClass style={{ height: "100%" }}>
        {/* {(isOffline || !isConnected) ? (
          <div className="offline-container">
            <h2>🔴 You are offline</h2>
            <p>Please check your internet connection.</p>
          </div>
        ) : ( */}
        <Wrapper
          noHorizontalMargin={true}
          header={<Wrapper.Header />}
          content={
            // <div>
            //   <Row className="pt-0">
            //     <Col md={3} className="p-0">
            //       <div
            //         className={`chatscreen__reset-css ${
            //           typeof selectedAssignedList === "object" &&
            //           Object.keys(selectedAssignedList).length === 0
            //             ? "chat_unselected"
            //             : "chat_selected"
            //         }`}
            //         style={{
            //           display: "flex",
            //           height: "calc(100vh - 70px)",
            //         }}
            //       >
            //         <ImagePicker />
            //         <DocumentPicker />
            //         <AudioPicker />
            //         <div
            //           className="chat-screen__left-content min-w-0"
            //           //  style={{width: '250px'}}
            //         >
            //           <LeftContent />
            //         </div>
            //       </div>
            //     </Col>
            //     <Col md={6} className="p-0">
            //       <div
            //         className="chat-screen__middle-content min-w-0"
            //         style={{
            //           // width: '75%',
            //           // flex: '1 1 auto'
            //           // flexGrow: "1",
            //           // maxWidth: 'calc(100% - 250px)'
            //         }}
            //       >
            //         <MiddleContent />
            //       </div>
            //     </Col>
            //     <Col md={3}>3</Col>
            //   </Row>
            // </div>
            <div
              className={`chatscreen__reset-css ${typeof selectedAssignedList === "object" &&
                Object.keys(selectedAssignedList).length === 0
                ? "chat_unselected"
                : "chat_selected"
                } ${showCustomerInfo === true ? "infoSelected" : "infoUnselected"
                }`}
            // style={{
            //   display: "flex",
            //   height: "calc(100vh - 70px)",
            //   // height: "100%",
            //   overflow: "hidden",
            // }}
            >
              <ImagePicker />
              <DocumentPicker />
              <AudioPicker />
              <div
                className="chat-screen__left-content min-w-0"
              //  style={{width: '250px'}}
              >
                <LeftContent />
              </div>
              <div
                className="chat-screen__middle-content min-w-0"
                style={{
                  // width: '75%',
                  // flex: '1 1 auto'
                  flexGrow: "1",
                  borderRight: "1px solid #d9d9d9",
                  // maxWidth: 'calc(100% - 250px)'
                }}
              >
                <MiddleContent />
              </div>
              {/* {showCustomerInfo && ( */}
              {typeof selectedAssignedList === "object" &&
                Object.keys(selectedAssignedList).length === 0 ? "" : <div className={`chat-screen__right-content`}>
                {/* <RightContent /> */}
                <ContactRightPartTheme />
              </div>}

              {/* )} */}
            </div>
          }
          className={"nocss"}
        />
        {/* )} */}
      </DataWrapperClass>
    </div>
  );
}
const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, "currentUser"),
  showCustomerInfo: chatSelector.getChatDynamic(state, "showCustomerInfo"),
  isConnected: globalStateSelector.getIsConnected(state),
  isOffline: globalStateSelector.getIsOffline(state),
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  uniqueTeamIds: chatSelector.getUniqueTeamIds(state, "uniqueTeamIds"),
  status: chatSelector.getAgentStatus(state),
});
const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  offlineState: (isOffline) => {
    dispatch(messageAction.offlineState({ isOffline }));
  },
  // dynamicUpdate: (type, messageData) => {
  //   dispatch(chatAction.dynamicUpdate(type, messageData));
  // }
});
export default connect(stateToProps, dispatchToProps)(ChatScreen);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/index.js